import React from 'react';
import * as S from './MappingModal.style';

const MappingModal = ({
  existingVariables,
  newVariables,
  mappingResults,
  isLocked,
  showMatched,
  showSimilar,
  showUnclassified,
  onVariableMap,
  onVariableUnmap,
  onToggleLock,
  onFilterToggle
}) => {
  const handleVariableMap = (existingVar, newVar) => {
    onVariableMap?.(existingVar, newVar);
  };

  const handleVariableUnmap = (mappingId) => {
    onVariableUnmap?.(mappingId);
  };

  const handleToggleLock = () => {
    onToggleLock?.();
  };

  const handleFilterToggle = (filterType) => {
    onFilterToggle?.(filterType);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'matched':
        return '●';
      case 'similar':
        return '●';
      case 'error':
        return '✓ X';
      case 'pending':
        return '⋯';
      default:
        return '';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'matched':
        return '#009444';
      case 'similar':
        return '#FFA500';
      case 'error':
        return '#CF1919';
      case 'pending':
        return '#666666';
      default:
        return '#666666';
    }
  };

  // 필터링된 변수들만 표시
  const filteredNewVariables = newVariables.filter(variable => {
    const mapping = mappingResults.find(m => m.newVariableId === variable.id);
    const status = mapping?.status || 'unclassified';
    
    if (status === 'matched' && !showMatched) return false;
    if (status === 'similar' && !showSimilar) return false;
    if ((status === 'unmatched' || status === 'error' || status === 'pending') && !showUnclassified) return false;
    
    return true;
  });

  return (
    <S.ModalContainer>
      <S.PageHeader>
        <S.PageTitle>데이터 매핑 화면입니다</S.PageTitle>
        <S.HeaderRight>
          <S.AutoSaveIcon />
          <S.AutoSaveText>자동 저장됨</S.AutoSaveText>
          <S.SettingsButton />
        </S.HeaderRight>
      </S.PageHeader>

      <S.MappingContainer>
        <S.MappingHeader>
          <S.LeftHeader>
            <S.SectionTitle>기존 변수</S.SectionTitle>
          </S.LeftHeader>
          <S.RightHeader>
            <S.RightHeaderLeft>
              <S.LockButton isLocked={isLocked} onClick={handleToggleLock}>
                {isLocked ? '🔒' : '🔓'}
              </S.LockButton>
              <S.SectionTitle>신규 변수</S.SectionTitle>
            </S.RightHeaderLeft>
            <S.MatchInfo>일치 항목이 792/800개 발견되었습니다</S.MatchInfo>
          </S.RightHeader>
        </S.MappingHeader>

        <S.MappingContent>
          <S.LeftColumn>
            {existingVariables.map((variable, index) => (
              <S.VariableCard key={variable.id} type="existing">
                <S.VariableName>{variable.name}</S.VariableName>
              </S.VariableCard>
            ))}
          </S.LeftColumn>

          <S.MappingArrow>→</S.MappingArrow>

          <S.RightColumn>
            <S.FilterSection>
              <S.FilterCheckbox>
                <S.Checkbox 
                  type="checkbox"
                  checked={showMatched}
                  onChange={() => handleFilterToggle('matched')}
                />
                <S.FilterLabel>일치</S.FilterLabel>
              </S.FilterCheckbox>
              <S.FilterCheckbox>
                <S.Checkbox 
                  type="checkbox"
                  checked={showSimilar}
                  onChange={() => handleFilterToggle('similar')}
                />
                <S.FilterLabel>유사</S.FilterLabel>
              </S.FilterCheckbox>
              <S.FilterCheckbox>
                <S.Checkbox 
                  type="checkbox"
                  checked={showUnclassified}
                  onChange={() => handleFilterToggle('unclassified')}
                />
                <S.FilterLabel>미분류</S.FilterLabel>
              </S.FilterCheckbox>
            </S.FilterSection>

            <S.VariableList>
              {filteredNewVariables.map((variable, index) => {
                const mapping = mappingResults.find(m => m.newVariableId === variable.id);
                const status = mapping?.status || 'unmatched';
                
                return (
                  <S.VariableCard 
                    key={variable.id} 
                    type="new" 
                    status={status}
                  >
                    <S.VariableName fontWeight={status === 'error' ? 800 : 400}>
                      {variable.name}
                    </S.VariableName>
                    
                    {status !== 'unmatched' && (
                      <S.StatusIndicator>
                        <S.StatusIcon color={getStatusColor(status)}>
                          {getStatusIcon(status)}
                        </S.StatusIcon>
                        {status === 'error' && (
                          <S.ErrorText>{getStatusIcon(status)}</S.ErrorText>
                        )}
                      </S.StatusIndicator>
                    )}
                  </S.VariableCard>
                );
              })}
              
              <S.PendingCard>
                <S.PendingText>
                  드롭다운 목록으로 보류 항목 선택 가능하도록 구현
                </S.PendingText>
              </S.PendingCard>
            </S.VariableList>
          </S.RightColumn>
        </S.MappingContent>

        <S.ActionButtons>
          <S.ActionButton />
          <S.ActionButton />
        </S.ActionButtons>
      </S.MappingContainer>

    </S.ModalContainer>
  );
};

export default MappingModal;